import { NumericFormat } from "react-number-format";

interface MonetaryTextProps {
  value: number;
}

const MonetaryText = ({ value }: Readonly<MonetaryTextProps>) => {
  return (
    <NumericFormat
      value={value}
      displayType="text"
      decimalSeparator="."
      decimalScale={2}
      fixedDecimalScale
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      prefix="£"
    />
  );
};

export default MonetaryText;
